// extracted by mini-css-extract-plugin
export default {"modal":"ContactForm_modal__y7utS","modalOverflow":"ContactForm_modalOverflow__-lS9b","row":"ContactForm_row__-vmLc","textarea":"ContactForm_textarea__QpNSq"};